import { Box, useDisclosure } from '@chakra-ui/react';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';

import { NewTravellerDialog } from '../../../features/activities/travellers/newTravellerDialog';
import { BaseButton, SelectOption } from '@invara-dev/react-base';
import { useMemo } from 'react';

type Props = {
  companyId: number | undefined;
  onCreated: (newTraveller: SelectOption[]) => void;
  disabledMessages: string[] | undefined;
  activityId: number | undefined;
  noDrag?: boolean;
};

export const NewTravellerInputAddon = (props: Props) => {
  const newTravellerDisclosure = useDisclosure();

  const disabledMessagesComputed = useMemo(() => {
    const messages: string[] = [];
    if (!props.companyId) {
      messages.push('Please select a company before adding new travelers');
    }
    if (props.disabledMessages) {
      props.disabledMessages.forEach((val) => {
        messages.push(val);
      });
    }
    return messages.length > 0 ? messages : undefined;
  }, [props.disabledMessages, props.companyId]);

  return (
    <Box>
      <BaseButton
        icon={faUserPlus}
        disabled={disabledMessagesComputed}
        toolTip={'Add New Travelers'}
        onClick={newTravellerDisclosure.onOpen}
      />
      {props.companyId && newTravellerDisclosure.open && (
        <NewTravellerDialog
          noDrag={props.noDrag}
          //formMethods={formMethods}
          //fieldArray={fieldArray}
          activityId={props.activityId}
          companyId={props.companyId}
          disclosure={newTravellerDisclosure}
          onCreated={props.onCreated}
        />
      )}
    </Box>
  );
};
